module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-board-2.66fb4c24.webp";